<script>

	import {onMount} from "svelte";

	export let filled = 0, all = 0;

	let calculated = "0%";

	onMount(() => {
		if (filled > all) {
			calculated = "100%";
		} else if (filled === 0 && all === 0) {
			calculated = "0.00%";
		} else {
			calculated = ((filled / all) * 100).toFixed(2) + "%";
		}
	})

</script>

<div class="table-bar-outer">
	<div class="table-bar" style="width: {calculated}"></div>
	<span class="table-bar-label">{calculated} - {filled}</span>
</div>
